<template>
    <v-row>
        <v-col cols="12">
            <h4 class="text-h4">{{ $t('Mi cuenta') }}</h4>
        </v-col>
        <v-col cols="12" lg="8">
            <my-account :data-user="dataUser" :data-country="dataCountry" :slug="slug" :locale="locale"></my-account>
        </v-col>

        <v-col cols="12" lg="4">
            <v-card class="text-center">
                <div>
                    <canvas id="qr-store"></canvas>
                </div>
                <v-btn
                    class="ml-3 mb-3 text-capitalize break-text"
                    @click="downloadQR"
                >
                    Descargar QR
                </v-btn>
            </v-card>
        </v-col>

        <v-col cols="12">
            <h4 class="text-h4">{{ $t('Ajustes de presentación') }}</h4>
        </v-col>
        <v-col cols="12" lg="8">
            <v-card class="mb-5">
                <v-card-text>
                    <v-form @submit.prevent="formUpdate" ref="refUpdate" lazy-validation>
                        <v-row no-gutters>
                            <!-- <v-col cols="12">
                                <h4>Ajustes de diseño</h4>
                                <v-divider class="mb-4"></v-divider>
                            </v-col> -->

                            <!-- if banner -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-switch
                                    v-model="data.ifBanner"
                                    inset
                                    :label="`${(data.ifBanner)?$t('Mostrar imagen en banner'):$t('Ocultar imagen en banner')}`"
                                ></v-switch>
                            </v-col>
                            <!-- end if banner -->

                            <!-- if banner -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-switch
                                    v-model="data.ifBody"
                                    inset
                                    :label="`${(data.ifBody)?$t('Mostrar imagen en body'):$t('Ocultar imagen en body')}`"
                                ></v-switch>
                            </v-col>
                            <!-- end if banner -->

                            <!-- banner color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu8" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color del body
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.bodyColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.bodyColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu8=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end banner color -->

                            <!-- banner color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu0" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color del banner
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.bannerColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.bannerColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu0=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end banner color -->

                            <!-- banner color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu1" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color icónos del banner
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.textbannerColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.textbannerColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu1=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end banner color -->

                            <!-- menu color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu2" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color del menú
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.navColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.navColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu2=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end menu color -->

                            <!-- text menu color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu3" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color texto navegación
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.textnavColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.textnavColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu3=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end text menu color -->

                            <!-- button color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu4" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color del botón
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.btnColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.btnColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu4=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end button color -->

                            <!-- text boton color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu5" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color texto botón
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.textbtnColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.textbtnColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu5=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end text boton color -->

                            <!-- contenido color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu10" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            {{ $t('Color de los títulos de producto') }}
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.titleCardColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.titleCardColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu10=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end contenido color -->

                            <!-- contenido color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu6" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color del contenido
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.contentColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.contentColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu6=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end contenido color -->

                            <!-- titulo color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu7" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color de los titulos de categoría
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.titleColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.titleColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu7=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end titulo color -->

                            <!-- titulo color -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-menu v-model="data.menu9" bottom offset-y :close-on-content-click="false" max-width="300px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mb-7 text-capitalize break-text"
                                            block
                                        >
                                            Color de los precios
                                            <v-sheet
                                                elevation="1"
                                                height="20px"
                                                width="80px"
                                                :color="data.priceColor"
                                                class="rounded ml-auto"
                                            ></v-sheet>
                                        </v-btn>
                                    </template>
                                    <v-card max-width="300px">
                                        <v-color-picker
                                            dot-size="28"
                                            hide-mode-switch
                                            swatches-max-height="188"
                                            v-model="data.priceColor"
                                        ></v-color-picker>
                                        <div class="text-right pb-2 px-2">
                                            <v-btn small dark @click="data.menu9=false">{{ $t('Aceptar') }}</v-btn>
                                        </div>
                                    </v-card>
                                </v-menu>
                            </v-col>
                            <!-- end titulo color -->

                            <!-- font family -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-select
                                    :items="listTypeFonts"
                                    :label="$t('Tipo de fuente')"
                                    outlined
                                    dense
                                    item-text="label"
                                    item-value="val"
                                    :rules="[rules.required]"
                                    v-model="data.fontFamily"
                                >
                                    <template v-slot:item="{ item }">
                                        <div :style="{fontFamily: item.val}">{{ item.label }}</div>
                                    </template>
                                </v-select>
                            </v-col>
                            <!-- end font family -->

                            <!-- tipo de header -->
                            <v-col cols="12" md="12" class="px-2">
                                <v-radio-group v-model="data.typeHeader">
                                    <template v-slot:label>
                                        <div>{{ $t('Tipo de header') }}</div>
                                    </template>
                                    <v-radio value="header1">
                                        <template v-slot:label>
                                            <div>
                                                Header tipo 1
                                                <v-menu
                                                    open-on-hover
                                                    top
                                                    offset-y
                                                    clickable
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            color="primary"
                                                            dark
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            x-small
                                                            icon
                                                        >
                                                            <v-icon>mdi-information</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-card width="500" height="40">
                                                        <v-row no-gutters align="center" class="pt-2">
                                                            <v-col cols="4">

                                                            </v-col>
                                                            <v-col cols="4" class="text-center">
                                                                Logo
                                                            </v-col>
                                                            <v-col cols="4" class="text-right pr-2">
                                                                <v-icon>mdi-magnify</v-icon>
                                                                <v-icon>mdi-account</v-icon>
                                                                <v-icon>mdi-cart</v-icon>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-menu>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="header2">
                                        <template v-slot:label>
                                            <div>
                                                Header tipo 2
                                                <v-menu
                                                    open-on-hover
                                                    top
                                                    offset-y
                                                    clickable
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            color="primary"
                                                            dark
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            x-small
                                                            icon
                                                        >
                                                            <v-icon>mdi-information</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-card width="500" height="40">
                                                        <v-row no-gutters align="center" class="pt-2">
                                                            <v-col cols="4" class="text-left pl-2">
                                                                Logo
                                                            </v-col>
                                                            <v-col cols="4" class="text-center">
                                                                <v-sheet
                                                                    color="grey lighten-4"
                                                                    elevation="0"
                                                                    height="25"
                                                                    outlined
                                                                    width="120"
                                                                    class="mx-auto"
                                                                ><small>buscar...</small></v-sheet>
                                                            </v-col>
                                                            <v-col cols="4" class="text-right pr-2">
                                                                <v-icon>mdi-account</v-icon>
                                                                <v-icon>mdi-cart</v-icon>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-menu>
                                            </div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                            <!-- END tipo de header -->

                            <!-- logo -->
                            <v-col cols="12" md="12" class="px-2">
                                <v-file-input
                                    :label="$t('Logo')"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-image"
                                    outlined
                                    dense
                                    v-model="data.logo"
                                    @change="changeLogo($event)"
                                ></v-file-input>
                            </v-col>
                            <!-- end logo -->

                            <!-- banner -->
                            <v-col cols="12" md="12" class="px-2" v-if="data.ifBanner">
                                <v-file-input
                                    :label="$t('Banner')"
                                    accept="image/png, image/jpeg, image/bmp"
                                    prepend-icon="mdi-image"
                                    outlined
                                    dense
                                    v-model="data.banner"
                                    @change="changeBanner($event)"
                                ></v-file-input>
                            </v-col>
                            <!-- end banner -->

                            <!-- favicon -->
                            <v-col cols="12" md="12" class="px-2">
                                <v-file-input
                                    :label="$t('Favicon')"
                                    accept="image/png"
                                    prepend-icon="mdi-image"
                                    outlined
                                    dense
                                    v-model="data.favicon"
                                    @change="changeFavicon($event)"
                                ></v-file-input>
                            </v-col>
                            <!-- end favicon -->

                            <!-- phone -->
                            <v-col cols="12" md="6" class="px-2 d-none">
                                <vue-tel-input-vuetify
                                    :label="$t('Celular *')"
                                    outlined
                                    dense
                                    :onlyCountries="['bo', 'us', 'es', 'ar', 'cl', 'co', 'ec', 'mx', 'pe', 've', 'br']"
                                    :default-country="defaultCountry"
                                    :rules="[rules.required]"
                                    :value="data.tmpPhone"
                                    @input="onInput"
                                    :error="errors['phone'] ? true :false"
                                    :error-messages="errors['phone'] ? errors['phone'][0] : ''"
                                ></vue-tel-input-vuetify>
                            </v-col>
                            <!-- end phone -->

                            <!-- body -->
                            <v-col cols="12" md="12" class="px-2" v-if="data.ifBody">
                                <v-file-input
                                    :label="$t('Body')"
                                    accept="image/png"
                                    prepend-icon="mdi-image"
                                    outlined
                                    dense
                                    v-model="data.body"
                                    @change="changeBody($event)"
                                ></v-file-input>
                            </v-col>
                            <!-- end body -->

                            <v-col cols="12"><v-divider class="mb-4"></v-divider></v-col>

                            <!-- if loadmore -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-switch
                                    v-model="data.ifLoadMore"
                                    inset
                                    class="mt-1"
                                    :label="$t('Botón cargar más en lista de productos')"
                                ></v-switch>
                            </v-col>
                            <!-- end if loadmore -->

                            <!-- if loadmore -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-text-field
                                    v-model="data.cantCategories"
                                    :label="$t('Cantidad de categorías para mostrar')"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    max="99999"
                                    step="1"
                                    :hint="$t('Si desea que se muestre todas las categorías poner 99999 por favor')"
                                ></v-text-field>
                            </v-col>
                            <!-- end if loadmore -->

                            <!-- num columns -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-select
                                    :items="mobileColumns"
                                    :label="$t('Número de columnas en celulares')"
                                    outlined
                                    dense
                                    :rules="[rules.required]"
                                    v-model="data.mobColumn"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="6" class="px-2">
                                <v-select
                                    :items="desktopColumns"
                                    :label="$t('Número de columnas en computadoras de escritorio')"
                                    outlined
                                    dense
                                    :rules="[rules.required]"
                                    v-model="data.deskColumn"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="6" class="px-2">
                                <v-text-field
                                    v-model="data.numDecimals"
                                    :label="$t('Cantidad de decimales')"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    max="99999"
                                    step="1"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="px-2">
                                <v-textarea
                                    v-model="data.decriptionStore"
                                    :label="$t('Descripción del tienda')"
                                    outlined
                                    dense
                                    rows="3"
                                ></v-textarea>
                            </v-col>
                            <!-- end num columns -->

                            <v-col cols="12"><v-divider class="mb-4"></v-divider></v-col>

                            <!-- money -->
                            <!-- <v-col cols="12" md="6" class="px-2">
                                <v-select
                                    :items="itemsMoney"
                                    label="Moneda"
                                    outlined
                                    dense
                                    :rules="[rules.required]"
                                    v-model="data.money"
                                ></v-select>
                            </v-col> -->
                            <!-- end money -->

                            <!-- <v-col cols="12"><v-divider class="mb-4"></v-divider></v-col> -->

                            <!-- boton carrito -->
                            <v-col cols="12" md="6" class="px-2">
                                <v-checkbox
                                    v-model="data.funCart"
                                    :label="$t('Función carrito')"
                                    hide-details
                                ></v-checkbox>
                                <v-checkbox
                                    v-model="data.funLogin"
                                    :label="$t('Función inicio de sesión')"
                                    hide-details
                                ></v-checkbox>
                            </v-col>
                            <!-- end boton carrito -->

                            <v-col cols="12"><v-divider class="my-4"></v-divider></v-col>

                            <v-col cols="12" sm="12" class="text-center">
                                <v-btn
                                    type="submit"
                                    dark
                                    color="primary"
                                    :loading="loading"
                                >
                                    {{ $t('Actualizar') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-overlay :value="overlay" absolute opacity=".9" z-index="10">
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>
            </v-card>
        </v-col>

        <v-col cols="12" lg="4">
            <h4>{{ $t('Vista previa') }}</h4>
            <!-- preview -->
            <v-img
                :src="data.previewFavicon"
                width="30"
                height="30"
                contain
            ></v-img>
            <v-card>
                <v-img
                    :src="data.previewBanner"
                    class="white--text align-end"
                    :gradient="`to top right, ${data.bannerColor}${(data.ifBanner)?'96':''}, ${data.bannerColor}${(data.ifBanner)?'59':''}`"
                    height="120px"
                >
                    <v-row class="pb-3" align="center">
                        <v-col cols="3" class="text-right">
                            <v-btn icon :color="data.textbannerColor" class="mr-2">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="text-center">
                            <v-img :src="data.previewLogo" max-width="100" max-height="50" contain class="mx-auto"></v-img>
                        </v-col>
                        <v-col cols="3">
                            <v-btn icon :color="data.textbannerColor" class="mr-2">
                                <v-icon>mdi-cart</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-tabs
                        align-with-title
                        slider-size="3"
                        :background-color="data.navColor"
                        :color="data.btnColor"
                    >
                        <v-tab>
                            <div :style="`color:${data.textnavColor}`">Item uno</div>
                        </v-tab>
                        <v-tab>
                            <div :style="`color:${data.textnavColor}`">Item dos</div>
                        </v-tab>
                    </v-tabs>
                </v-img>
                <v-card-text class="bg" :style="(data.ifBody)?`background-image: url(${data.previewBody})`:`background-color: ${data.bodyColor}`">
                    <div class="mb-2">
                        <h4 :style="`color:${data.titleColor}`">Titúlo</h4>
                        <span :style="`color:${data.titleCardColor}`">Título producto</span>
                        <br><strong :style="`color:${data.priceColor}`">56 {{ data.money }}</strong>
                        <div :style="`color:${data.contentColor}`">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda enim culpa est doloribus, rerum pariatur fuga voluptatum consequatur.
                        </div>
                    </div>
                    <v-btn :color="data.btnColor" :style="`color:${data.textbtnColor}`">
                        Boton
                    </v-btn>
                </v-card-text>
                <v-card-actions :style="{background: data.navColor}">
                    &nbsp;
                </v-card-actions>
            </v-card>
            <!-- end preview -->

        </v-col>

        <v-col cols="12">
            <h4 class="text-h4">{{ $t('Banners de mi tienda') }}</h4>
        </v-col>
        <v-col cols="12">
            <banners-store :slug="slug"></banners-store>
        </v-col>

        <v-col cols="12">
            <h4 class="text-h4">{{ $t('Redes sociales') }}</h4>
        </v-col>
        <v-col cols="12">
            <socialnetworks-store :slug="slug"></socialnetworks-store>
        </v-col>

        <template v-if="data.cant_qr > 0 && data.type_store_id === 3">
            <v-col cols="12">
                <h4 class="text-h4 mb-4">QR de las mesas</h4>

                <a href="/imprimir-qr" target="_blank">
                    <v-btn color="primary" dark>
                    <v-icon left>mdi-printer</v-icon>
                    Imprimir
                    </v-btn>
                </a>
            </v-col>
        </template>

        <v-col cols="12" v-if="typeStore == 'gastronomic'">
            <h4 class="text-h4">Mapa de mesas</h4>
        </v-col>
        <v-col cols="12" v-if="typeStore == 'gastronomic'">
            <table-map-store :slug="slug"></table-map-store>
        </v-col>
    </v-row>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
import qrcode from "qrcode";
export default {
    components: {
        VueTelInputVuetify,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            itemsMoney: ['$','Bs.','$','$','$','US$','EUR','$','S/','$', 'R$'],
            mobileColumns: [1, 2],
            desktopColumns: [3, 4, 5, 6],
            data: {
                store_id: '',
                bannerColor: '',
                menu0: false,

                textbannerColor: '',
                menu1: false,

                navColor: '',
                menu2: false,

                textnavColor: '',
                menu3: false,

                ifBanner: true,
                logo: null,
                previewLogo: '',
                banner: null,
                previewBanner: '',
                favicon: null,
                previewFavicon: '',

                btnColor: '',
                menu4: false,

                textbtnColor: '',
                menu5: false,

                contentColor: '',
                menu6: false,

                titleColor: '',
                menu7: false,

                priceColor: '',
                menu9: false,

                fontFamily: '',

                ifBody: false,
                menu8: false,

                titleCardColor: '',
                menu10: false,

                bodyColor: '',
                body: null,
                previewBody: '',
                money: '',
                ifLoadMore: true,
                cantCategories: null,

                mobColumn: 1,
                deskColumn: 3,

                numDecimals: null,

                decriptionStore: '',

                typeHeader: '',

                funCart: false,
                funLogin: false,

                tmpPhone: '',
                phoneCode: '',
                phoneIso: '',
                phoneValid: false,
                phone: '',
                cant_qr: 0,
                type_store_id: 0
            },
            tmpPreviewLogo: '',
            tmpPreviewBanner: '',
            tmpPreviewFavicon: '',
            listTypeFonts: [
                {label: 'Abel', val: "'Abel', sans-serif"},
                {label: 'Abril Fatface', val: "'Abril Fatface', cursive"},
                {label: 'Acme', val: "'Acme', sans-serif"},
                {label: 'Aftika', val: "'aftika', sans-serif"},
                {label: 'Amatic SC', val: "'Amatic SC', cursive"},
                {label: 'Archivo Black', val: "'Archivo Black', sans-serif"},
                {label: 'Bebas Neue', val: "'Bebas Neue', sans-serif"},
                {label: 'Black Ops One', val: "'Black Ops One', cursive"},
                {label: 'Cabin', val: "'Cabin', sans-serif"},
                {label: 'Caveat', val: "'Caveat', cursive"},
                {label: 'Comfortaa', val: "'Comfortaa', cursive"},
                {label: 'Cormorant Garamond', val: "'Cormorant Garamond', serif"},
                {label: 'Dancing Script', val: "'Dancing Script', cursive"},
                {label: 'Dosis', val: "'Dosis', sans-serif"},
                {label: 'Fira Sans', val: "'Fira Sans', sans-serif"},
                {label: 'Fira Sans Condensed', val: "'Fira Sans Condensed', sans-serif"},
                {label: 'Fjalla One', val: "'Fjalla One', sans-serif"},
                {label: 'Gluten', val: "'Gluten', cursive"},
                {label: 'Handjet', val: "'Handjet', cursive"},
                {label: 'IBM Plex Mono', val: "'IBM Plex Mono', monospace"},
                {label: 'Indie Flower', val: "'Indie Flower', cursive"},
                {label: 'Josefin Sans', val: "'Josefin Sans', sans-serif"},
                {label: 'Kanit', val: "'Kanit', sans-serif"},
                {label: 'Karla', val: "'Karla', sans-serif"},
                {label: 'KoHo', val: "'KoHo', sans-serif"},
                {label: 'Libre Baskerville', val: "'Libre Baskerville', serif"},
                {label: 'Lobster', val: "'Lobster', cursive"},
                {label: 'Lora', val: "'Lora', serif"},
                {label: 'MarrSansCond', val: "'marr-sans-cond', sans-serif"},
                {label: 'Montserrat', val: "'Montserrat', sans-serif"},
                {label: 'Nanum Gothic', val: "'Nanum Gothic', sans-serif"},
                {label: 'Nanum Myeongjo', val: "'Nanum Myeongjo', serif"},
                {label: 'Newsreader', val: "'Newsreader', serif"},
                {label: 'Noto Sans', val: "'Noto Sans', sans-serif"},
                {label: 'Open Sans', val: "'Open Sans', sans-serif"},
                {label: 'Oswald', val: "'Oswald', sans-serif"},
                {label: 'Pattaya', val: "'Pattaya', sans-serif"},
                {label: 'Phudu', val: "'Phudu', cursive"},
                {label: 'Play', val: "'Play', sans-serif"},
                {label: 'Playfair Display', val: "'Playfair Display', serif"},
                {label: 'Prompt', val: "'Prompt', sans-serif"},
                {label: 'Qwitcher Grypen', val: "'Qwitcher Grypen', cursive"},
                {label: 'Rajdhani', val: "'Rajdhani', sans-serif"},
                {label: 'Raleway', val: "'Raleway', sans-serif"},
                {label: 'Roboto', val: "'Roboto', sans-serif"},
                {label: 'Roboto Mono', val: "'Roboto Mono', monospace"},
                {label: 'Roboto Slab', val: "'Roboto Slab', serif"},
                {label: 'Rubik', val: "'Rubik', sans-serif"},
                {label: 'Rubik Iso', val: "'Rubik Iso', cursive"},
                {label: 'Sanomat', val: "'sanomat', cursive"},
                {label: 'Sedgwick Ave Display', val: "'Sedgwick Ave Display', cursive"},
                {label: 'Signika Negative', val: "'Signika Negative', sans-serif"},
                {label: 'Sniglet', val: "'Sniglet', cursive"},
                {label: 'Source Code Pro', val: "'Source Code Pro', monospace"},
                {label: 'Stint Ultra Condensed', val: "'Stint Ultra Condensed', serif"},
                {label: 'Teko', val: "'Teko', sans-serif"},
                {label: 'Tilt Prism', val: "'Tilt Prism', cursive"},
                {label: 'Tulpen One', val: "'Tulpen One', cursive"},
                {label: 'Ubuntu', val: "'Ubuntu', sans-serif"},
                {label: 'Varela Round', val: "'Varela Round', sans-serif"},
                {label: 'Work Sans', val: "'Work Sans', sans-serif"},
            ],
            defaultCountry: 'bo',
            typeStore: '',
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            errors: {},
        }
    },
    props: ['slug', 'dataUser', 'dataCountry', 'locale'],
    mounted() {
        this.getDataStore(),
        this.generateQR()
    },
    methods: {
        onInput(formattedNumber, { number, valid, country }) {
            this.data.phoneCode = '+'+country.dialCode
            this.data.phone = number.significant
            this.data.tmpPhone = number.international
            this.data.phoneIso = country.iso2
            this.data.phoneValid = valid
        },
        /**
         * get data
         */
        async getDataCantQr() {
            const response = await axios.get(`/admin/qr-codes/${this.data.store_id}`);
            this.data.cant_qr = response.data.cant_qr;
            this.data.type_store_id = response.data.type_store_id;
        },
        async getDataStore() {
            await axios.post('/admin/data-mystore', {})
            .then((response) => {
                // console.log(response);
                this.data.store_id = response.data.store_id
                this.data.bannerColor = response.data.banner_color
                this.data.textbannerColor = response.data.textbanner_color
                this.data.navColor = response.data.nav_color
                this.data.textnavColor = response.data.textnav_color
                this.data.ifBanner = (response.data.if_banner)?true:false

                this.data.previewLogo = response.data.logo
                this.tmpPreviewLogo = response.data.logo

                this.data.previewBanner = response.data.banner
                this.tmpPreviewBanner = response.data.banner

                this.data.previewFavicon = response.data.favicon
                this.tmpPreviewFavicon = response.data.favicon

                this.data.btnColor = response.data.btn_color
                this.data.textbtnColor = response.data.textbtn_color
                this.data.contentColor = response.data.content_color
                this.data.titleColor = response.data.title_color
                this.data.titleCardColor = response.data.titlecard_color
                this.data.priceColor = response.data.price_color
                this.data.fontFamily = response.data.font_family

                this.data.ifBody = (response.data.if_body)?true:false
                this.data.bodyColor = response.data.body_color
                this.data.previewBody = response.data.body

                this.data.money = response.data.money

                this.data.ifLoadMore = (+response.data.if_load_more)?true:false

                this.data.cantCategories = response.data.cant_categories

                this.data.mobColumn = response.data.mob_columns
                this.data.deskColumn = response.data.desk_columns

                this.data.numDecimals = response.data.number_decimals

                this.data.decriptionStore = response.data.description_store

                this.data.typeHeader = response.data.type_header

                this.data.funCart = (response.data.fun_cart)?true:false
                this.data.funLogin = (response.data.fun_login)?true:false

                this.data.tmpPhone = response.data.code + response.data.phone
                this.getDataCantQr()

                this.typeStore = response.data.type_store
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        changeLogo(event) {
            if (event) {
                const file = event;
                this.data.previewLogo = URL.createObjectURL(file);
                this.data.logo = file;
                return
            }
            this.data.previewLogo = this.tmpPreviewLogo
            this.data.logo = null
        },
        changeBanner(event) {
            if (event) {
                const file = event;
                this.data.previewBanner = URL.createObjectURL(file);
                this.data.banner = file;
                return
            }
            this.data.previewBanner = this.tmpPreviewBanner
            this.data.banner = null
        },
        changeFavicon(event) {
            if (event) {
                const file = event;
                this.data.previewFavicon = URL.createObjectURL(file);
                this.data.favicon = file;
                return
            }
            this.data.previewFavicon = this.tmpPreviewFavicon
            this.data.favicon = null
        },
        changeBody(event) {
            if (event) {
                const file = event;
                this.data.previewBody = URL.createObjectURL(file);
                this.data.body = file;
                return
            }
            this.data.previewBody = this.tmpPreviewFavicon
            this.data.body = null
        },
        /**
         * register
         */
        async formUpdate() {
            if (this.$refs.refUpdate.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('banner_color', this.data.bannerColor)
                formData.append('textbanner_color', this.data.textbannerColor)
                formData.append('nav_color', this.data.navColor)
                formData.append('textnav_color', this.data.textnavColor)
                formData.append('if_banner', (this.data.ifBanner)?1:0)
                formData.append('logo', this.data.logo)
                formData.append('banner', this.data.banner)
                formData.append('favicon', this.data.favicon)
                formData.append('btn_color', this.data.btnColor)
                formData.append('textbtn_color', this.data.textbtnColor)
                formData.append('content_color', this.data.contentColor)
                formData.append('title_color', this.data.titleColor)
                formData.append('titlecard_color', this.data.titleCardColor)
                formData.append('price_color', this.data.priceColor)
                formData.append('font_family', this.data.fontFamily)
                formData.append('if_body', (this.data.ifBody)?1:0)
                formData.append('body_color', this.data.bodyColor)
                formData.append('body', this.data.body)
                formData.append('money', this.data.money)
                formData.append('if_load_more', (this.data.ifLoadMore)?1:0)
                formData.append('cant_categories', this.data.cantCategories)
                formData.append('mob_columns', this.data.mobColumn)
                formData.append('desk_columns', this.data.deskColumn)
                formData.append('number_decimals', this.data.numDecimals)
                formData.append('description_store', this.data.decriptionStore)
                formData.append('type_header', this.data.typeHeader)
                formData.append('fun_cart', this.data.funCart?1:0)
                formData.append('fun_login', this.data.funLogin?1:0)
                formData.append('phone', this.data.phone)
                formData.append('code', this.data.phoneCode)
                formData.append('iso2', this.data.phoneIso)
                formData.append('_method', 'PUT')

                await axios.post('/admin/update-mystore', formData)
                .then((response) => {
                    // console.log(response);
                    if (response.data == 'ok') {
                        this.$alert('', this.$t('Datos actualizado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                        this.data.logo = null
                        this.data.banner = null
                        this.$refs.refUpdate.resetValidation()
                    }
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error);
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.loading = false
                })
            }
        },
        generateQR() {
            let qrstore = document.querySelector('#qr-store');
            let url = `https://cat.myquickone.com/${this.slug}`;

            qrcode.toCanvas(qrstore, url, { errorCorrectionLevel: 'H' }, (error) => {
                if (error) console.error(error)
                console.log('success!');
            });
        },
        downloadQR() {
            const canvas = document.querySelector('#qr-store');
            const ctx = canvas.getContext('2d');

            // Descargar
            const link = document.createElement('a');
            link.download = 'qr-store.png'; // nombre del archivo
            link.href = canvas.toDataURL('image/png'); // convertir canvas a imagen
            link.click();
        }
    },
}
</script>
<style>
.break-text {
    white-space: normal;
    word-break: break-word;
    display: inline-block;
    text-align: left;
    height: auto !important;
    min-height: 38px;
}
</style>
